module.exports = __webpack_public_path__ + "static/img/10a.535823b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/art/10a.jpg
// module id = e7OI
// module chunks = 0